module.exports = __webpack_public_path__ + "img/Wp_2013.2e9ab6eb.png";